import { checkVersion } from '@/api/device'
import type { Device } from '@/types/device'

export type State = 'idle' | 'checking' | 'downloading' | 'ready' | 'updating'
export type DownloadInfo = {
  version: string
  url: string
  checksum: string
  deprecated?: boolean
}

export abstract class Updater {
  private state: State

  constructor() {
    this.state = 'idle'
  }

  async checkUpdates(device: Device): Promise<DownloadInfo | null> {
    if (['checking', 'downloading'].includes(this.state)) {
      return null
    }

    try {
      this.state = 'checking'
      const platform = this._getPlatform()
      const response = await checkVersion({
        ...device,
        platform
      })

      if (!response.version) {
        this.state = 'idle'
        return null
      }

      this.state = 'downloading'
      await this._downloadUpdate(response)
      this.state = 'ready'
      return response
    } catch {
      this.state = 'idle'
      return null
    }
  }

  async notifyAppReady() {}

  abstract getVersion(): Promise<{ name: string; build: string; native?: string }>
  abstract _getPlatform(): string
  abstract _downloadUpdate(info: DownloadInfo): Promise<void>
  abstract installUpdate(): Promise<void>
}
